import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getProductsEarnings } from "reducers/reports";
import Loader from "components/Loader";
import BarGraph from "./BarGraph";
import Filters from "./Filters";
import { fourthReportTransformerbarChart, horizontalScrollBarStyle } from "utils";
import { USER_TYPE } from "utils/constants";
import { Paper, Box, Typography } from "@mui/material";

function ProductsEarningsReport({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedCompany,
  handleCampanyChange,
  selectedBrokers,
  handleBrokerChange,
  handleFilter,
  resetFilterBtn
}) {
  const { loading, data, filters } = useSelector(state => state.reports);
  const { theme, data: userData } = useSelector(state => state.user);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getProductsEarnings());
  }, [dispatch, filters]);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Filters
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            selectedCompany={selectedCompany}
            handleCampanyChange={handleCampanyChange}
            selectedBrokers={selectedBrokers}
            handleBrokerChange={handleBrokerChange}
            handleFilter={handleFilter}
            resetFilterBtn={resetFilterBtn}
            reportData={data?.productsEarnings?.insurance}
          />
          {data?.productsEarnings?.insurance?.length > 0 ? (
            <>
              <Paper
                sx={theme => ({ bgcolor: theme.palette.background.default })}
                elevation={0}
              >
                <Box
                  height={data?.productsEarnings?.insurance.length * 30 + 100}
                  style={{ overflowY: "hidden", overflowX: "scroll" }}
                  sx={theme => (horizontalScrollBarStyle(theme))}
                >
                  <BarGraph
                    theme={theme}
                    user={userData?.me?.type !== USER_TYPE.BROKER}
                    indexBy={"name"}
                    keys={["insuranceAmount", "mortgageAmount"]}
                    data={fourthReportTransformerbarChart(
                      data?.productsEarnings
                    )}
                  />
                </Box>
              </Paper>
            </>
          ) : (
            <Typography variant="h5" color="text.primary" component="h5">
              There is no report yet
            </Typography>
          )}
        </>
      )}
    </>
  );
}

export default ProductsEarningsReport;
